<template>
    <div>
        <tabs-component></tabs-component>
        <section class="content">
            <div class="row">
                <div class="col-md-6">
                    <b-form @submit.prevent="onSubmit" class="form-group">
                        <b-form-group id="form_acccount_password"
                                      label="Current password:"
                                      label-for="form_account_password">
                            <b-form-input id="form_account_password"
                                          type="password"
                                          v-model="form.password"
                                          v-validate="'required'"
                                          :state="errors.has('password') ? false: null"
                                          name="password">
                            </b-form-input>
                            <em v-if="errors.has('password')" class="text-danger">
                                {{ errors.first('password') }}
                            </em>
                        </b-form-group>
                        <b-form-group id="form_acccount_new_password"
                                      label="New password:"
                                      label-for="form_account_password">
                            <b-form-input id="form_acccount_new_password"
                                          type="password"
                                          v-model="form.password_new"
                                          v-validate="'required'"
                                          :state="errors.has('new_password') ? false: null"
                                          name="new_password">
                            </b-form-input>
                            <em v-if="errors.has('new_password')" class="text-danger">
                                {{ errors.first('new_password') }}
                            </em>
                        </b-form-group>
                        <b-form-group id="form_acccount_password_repeat"
                                      label="Repeat new password:"
                                      label-for="form_acccount_new_password_repeat">
                            <b-form-input id="form_acccount_new_password_repeat"
                                          type="password"
                                          v-model="form.password_new_confirmation"
                                          v-validate="{ is: form.password_new }"
                                          :state="errors.has('password_confirmation') ? false: null"
                                          name="password_confirmation">
                            </b-form-input>
                            <em v-if="errors.has('password_confirmation')" class="text-danger">
                                {{ errors.first('password_confirmation') }}
                            </em>
                        </b-form-group>
                        <b-btn variant="success"
                               :disabled="loading.save"
                               type="submit">
                            <font-awesome-icon icon="save" class="mr-1" />
                            <span>Save</span>
                            <b-spinner
                                v-if="loading.save"
                                small
                                class="ml-2" />
                        </b-btn>
                    </b-form>
                </div>
                <div class="col-md-6">

                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import TabsComponent from './Tabs.vue';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        name: "Password",
        components: {
            TabsComponent,
        },
        created() {
            this.$store.dispatch('fetchAccount')
                .then(() => {
                    this.form.id = this.$store.getters.getAccount.id;
                });
        },
        data: function () {
            return {
                form: {
                    id: '',
                    password: '',
                    password_new: '',
                    password_new_confirmation: '',
                },
                loading: {
                    save: false,
                }
            }
        },
        methods: {
            onSubmit: function() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading.save = true;
                        this.$store.dispatch('editAccountPassword', this.form).finally(() => {
                            this.loading.save = false;
                        });
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>